import _ from "lodash";
import ZRegexX from "./ZRegexX";
import ImageX from "./ImageX";
import { v1 } from "uuid";

class ZClipBoard {

  /**
   * 
   * @param {import("react").ClipboardEvent} e 
   */
  static getHTMLData(e){
    return e?.clipboardData?.getData("text/html");
  }

  /**
   * 
   * @param {import("react").ClipboardEvent} e 
   */
  static getFiles(e){
    return e?.clipboardData?.files;
  }

  /**
   * 
   * @param {import("react").ClipboardEvent} e 
   */
  static getItems(e){
    return e?.clipboardData?.items;
  }

  /**
   * 
   * @param {import("react").ClipboardEvent} e 
   */
  static async ExtractFile(e, onFile){
    //html
    let html = this.getHTMLData(e);
    if(!_.isEmpty(html)){
      let src = ZRegexX.ExtractImageSrcFromHTML(html);
      if(src){
        e.preventDefault();
        try{
          let file = await ImageX.Base64toBlob(src);
          let link = URL.createObjectURL(file);
          file.src = link;
          let ext = file.type.split("/")[1] || "png";
          file.name = `pasted_image${v1()}.${ext}`;
          onFile?.(file);
          return;
        }catch{}
      }
    }

    if(e?.clipboardData?.files){
      let files = this.getFiles(e);
      let file = files?.[0];
      if(file){
        e.preventDefault();
        let link = URL.createObjectURL(file);
        file.src = link;
        try{
          onFile?.(file);
          return;
        }catch{}
      }
    }

    if(e?.clipboardData?.items){
      let items = this.getItems(e);
      for(let i = 0; i < items.length; i++){
        let item = items[i];
        if(item.kind === "file"){
          e.preventDefault();
          let file = item.getAsFile();
          const reader = new FileReader();
          reader.onload = (ev) => {
            file.src = ev.target.result;
            try{
              onFile?.(file);
            }catch{}
          };
        }
      }
    }
  }

}

export default ZClipBoard;